import { motion } from "framer-motion";
import { ArrowUpRight, Scale, Hammer } from "lucide-react";
import { track } from "@/lib/api";

const SD_DEMAND = "https://stavebne-dopyty.sk/pridat-dopyt";

/**
 * Cross-promotion band for the sister portal Stavebné-dopyty.sk:
 * compare insulation prices + find other construction works.
 */
export default function SdPromo({ context = "" }) {
  return (
    <section className="bg-ink py-16 border-t border-white/10" data-testid="sd-promo">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <motion.a
            href={SD_DEMAND} target="_blank" rel="noreferrer" data-testid="sd-compare-link"
            onClick={() => track("sd_click", `compare-${context}`)}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="group border border-white/12 hover:border-gold/60 bg-ink-2 p-7 md:p-8 transition-colors flex items-start gap-4"
          >
            <Scale className="w-8 h-8 text-gold shrink-0 mt-1" />
            <div>
              <h3 className="font-display text-2xl md:text-3xl text-white group-hover:text-gold transition-colors">
                Chcete si porovnať cenu?
              </h3>
              <p className="text-white/60 text-sm mt-2 leading-relaxed">
                Zadajte dopyt na portáli <span className="text-white font-semibold">Stavebné-dopyty.sk</span> a získajte
                nezáväzné cenové ponuky od viacerých overených firiem.
              </p>
              <span className="inline-flex items-center gap-1 text-gold text-sm font-mono2 uppercase tracking-widest mt-4">
                Zadať dopyt <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </span>
            </div>
          </motion.a>

          <motion.a
            href={SD_DEMAND} target="_blank" rel="noreferrer" data-testid="sd-otherworks-link"
            onClick={() => track("sd_click", `otherworks-${context}`)}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: 0.08 }}
            className="group border border-white/12 hover:border-gold/60 bg-ink-2 p-7 md:p-8 transition-colors flex items-start gap-4"
          >
            <Hammer className="w-8 h-8 text-gold shrink-0 mt-1" />
            <div>
              <h3 className="font-display text-2xl md:text-3xl text-white group-hover:text-gold transition-colors">
                Potrebujete ďalšie stavebné práce?
              </h3>
              <p className="text-white/60 text-sm mt-2 leading-relaxed">
                Strecha, okná, omietky, elektrina či rekonštrukcia — nájdite remeselníkov a firmy
                na jednom mieste cez náš portál stavebných dopytov.
              </p>
              <span className="inline-flex items-center gap-1 text-gold text-sm font-mono2 uppercase tracking-widest mt-4">
                Pozrieť Stavebné-dopyty.sk <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </span>
            </div>
          </motion.a>
        </div>
      </div>
    </section>
  );
}
